<template>
  <div class="shopManage">
    <div class="title">
      <el-breadcrumb >
       <el-breadcrumb-item :to="{ path: '/home/shopInfoManage' }">店铺管理</el-breadcrumb-item>
        <el-breadcrumb-item>店铺申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main"
         v-loading="load">
      <el-card>
        <div class="subtitle">
          <h4>店铺申请</h4>
        </div>
        <div class="list"
             v-if="shopTypeList.length > 0">
          <div class="item"
               v-for="(item, index) in shopTypeList"
               :key="index">
            <div class="til">
              <p>{{ shopType[item.type - 1] }}</p>
            
              <span  v-if='item.amount==0'>首店/首年免费</span>
                <span v-else>{{ item.amount }} 元</span>
            </div>
            <p class="hide">{{ item.explain }}</p>
            <el-button v-if="item.is_pay && item.type != 1"
                       type="primary"
                       size="small"
                       @click="shopApply(item.type, 0,item.amount)"
                       :disabled="item.type != 1">已购买</el-button>
            <div v-else>
              <el-button v-if="item.audit_status == 0"
                         type="primary"
                        
                         size="small"
                         @click="shopApply(item.type, 0,item.amount)">申 请</el-button>
              <el-button v-else
                         type="primary"
                         size="small"
                          :disabled='item.audit_status==5'
                         @click="shopApply(item.type, item.shop_id,item.amount)">
                         <span v-if="item.audit_status==1">
                             待审核
                         </span>
                         <span v-if="item.audit_status==2">
                             待审核
                         </span>
                         <span v-if="item.audit_status==3">
                             审核通过
                         </span>
                         <span v-if="item.audit_status==4">
                             审核失败
                         </span>
                         <span v-if="item.audit_status==5">
                             已申请
                         </span>
                        </el-button>
            </div>
          </div>
        </div>
        <div class="line"
             v-if="shopTypeList.length > 0">
          <div class="til">
            <h4>店铺申请流程</h4>
          </div>
          <div class="line-list">
            <div class="item">
              <span>01</span>
              <p>申请店铺类型</p>
            </div>
            <div class="item">
              <span>02</span>
              <p>上传相应资料</p>
            </div>
            <div class="item">
              <span>03</span>
              <p>等待审核</p>
            </div>
            <div class="item">
              <span>04</span>
              <p>支付押金</p>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data () {
    return {
      shopList: [], //已有店铺
      shopTypeList: [], //店铺类型
      shopType: ["品牌官方店", "品牌旗舰店", "专卖店", "专营店"],
      status_opt: ["待审核", "审核通过", "审核拒绝"],
      load: false,
      payShop: [],
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  created () {
    this.getShopList();
  },
  methods: {
    ...mapActions({
      shoptypelist: "detect/shoptypelist",
    }),
    changeFixed (val) {
      return val.toFixed(2)
    },
    getShopList () {
      this.load = true;
      this.shoptypelist({ token: this.getToken }).then(res => {
        this.load = false;
        if (res.data.code == 1) {
          localStorage.setItem("shop", JSON.stringify(res.data.data));
          this.shopTypeList = res.data.data.type[0];
          this.payShop = res.data.data.shop;
          this.shopTypeList.forEach((item) => {
            item.is_pay = this.payShop.some((val) => item.id == val.id);
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    shopApply (type, id, amount) {
      sessionStorage.setItem('shopAmount', amount)
      if (id == 0) {
        this.$router.push({
          path: `/home/shopApply/${type}`,
        });
      } else {
        this.$router.push({
          path: `/home/shopApply/${type}/${id}`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shopManage {
  .title {
    width: 100%;
    background: #fff;
    padding: 15px 32px;
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    p {
      font-size: 20px;
      color: #000000;
      margin-left: 0;
    }
  }
  .main {
    min-width: 1200px;
    .el-card {
      min-height: 780px;
    }
    padding: 20px;
    .subtitle {
      margin-bottom: 35px;
      h4 {
        font-size: 18px;
        padding-left: 20px;
        line-height: 18px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 2px;
          background: #2448ff;
        }
      }
    }
    .list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .item {
        margin: 18px;
        width: 330px;
        height: 220px;
        background: #ffffff;
        box-shadow: 0px 6px 24px 1px rgba(0, 10, 106, 0.08);
        border-radius: 8px;
        padding: 22px;
        position: relative;
        transition: all 0.1s;
        &:hover {
          box-shadow: 0px 6px 24px 1px rgba(0, 0, 0, 0.2);
        }
        .til {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          p {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #f60a0a;
          }
        }
        & > p {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
        }
        .el-button {
          position: absolute;
          right: 22px;
          bottom: 22px;
        }
      }
    }
    .line {
      margin-top: 22px;
      .til {
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 400px;
          height: 1px;
          transform: translateX(-50%);
          background: #dddddd;
        }
        h4 {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          line-height: 56px;
          text-align: center;
        }
      }
      .line-list {
        margin: 40px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item {
          width: 20%;
          height: 100px;
          background: #ffffff;
          border: 1px solid #999999;
          border-radius: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            width: 48px;
            height: 48px;
            background: #ffffff;
            border: 1px solid #2448ff;
            border-radius: 50%;
            display: block;
            text-align: center;
            line-height: 48px;
            font-size: 24px;
            font-weight: bold;
            color: #2448ff;
          }
          p {
            width: 96px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #2448ff;
            line-height: 56px;
            margin-left: 16px;
          }
        }
      }
    }
  }
}
::v-deep .el-upload-list__item-name {
  cursor: pointer;
}
.hide {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
</style>